export default __webpack_public_path__ + "static/media/ellipse-top-left.9e18c286.svg";